document.addEventListener("DOMContentLoaded", function() {
  const block = document.querySelector('section.funds-preview');
  const numberFormatter = new Intl.NumberFormat('nb-NO', {minimumFractionDigits: 2, maximumFractionDigits: 2});

  if(block) {
    const funds = block.querySelectorAll('.fund');
    if(funds.length > 0) {
      funds.forEach(function(fund, index) {
        const values = fund.querySelector('.range').getAttribute('data-values').split(',');
        const input = fund.querySelector('input');
        const slug = fund.getAttribute('data-slug');
        const icon = fund.querySelector('svg');

        if(icon) {
          let iconTop;
          let iconOffset = null;
          icon.querySelectorAll('path').forEach(function(path, index) {
            if(iconOffset == null) {
              iconOffset = path.getBoundingClientRect().top;
              iconTop = path.getBoundingClientRect().height;
            }
            else if(path.getBoundingClientRect().top < iconOffset) {
              iconTop = path.getBoundingClientRect().height;
            }
          });
          icon.style.marginTop = (0 - (iconTop)) + 'px';
        }

        fund.querySelector('.wrapper >a').addEventListener('click', function(e) {
          if (e.target.tagName === 'INPUT') {
            e.preventDefault();
            return false;
          }
        });

        fund.querySelector('.labels').addEventListener('click', function(e) {
          e.preventDefault();
        });

        fund.querySelectorAll('.labels span').forEach(function(span) {
          span.addEventListener('click', function(e) {
            e.preventDefault();
            const parent = span.parentElement; // the .labels element
            const siblings = Array.from(parent.children);
            const index = siblings.indexOf(span);

            input.value = index;
            input.dispatchEvent(new Event('input'));
          });
        });

        input.oninput = function() {
          block.querySelectorAll('.fund[data-slug="' + slug + '"]').forEach(function(fund, index) {
            fund.querySelector('input').value = input.value;
            const value = parseFloat(values[input.value]);
            fund.querySelector('.range-output').innerHTML = isNaN(value) ? '-' : (numberFormatter.format(value) + '%');
          });
        };

        if(window.innerWidth < 1024) {
          input.ontouchstart = function() {
            $('.slick-slideshow').slick('slickSetOption', {draggable: false, swipe: false, swipeToSlide: false, touchMove: false}, true);
          }
          input.ontouchend = function() {
            $('.slick-slideshow').slick('slickSetOption', {draggable: true, swipe: true, swipeToSlide: true, touchMove: true}, true);
          }
        }
        else {
          input.onmousedown = function() {
            $('.slick-slideshow').slick('slickSetOption', {draggable: false}, true);
          }
          input.onclick = function() {
            setTimeout(function() {
              $('.slick-slideshow').slick('slickSetOption', {draggable: true}, true);
            }, 10);
          }
        }
        // Set the default value
        input.oninput();

        block.querySelectorAll('.fund[data-slug="' + slug + '"]').forEach(function(fund, index) {
          fund.querySelector('input').value = input.value;
          const value = parseFloat(values[input.value]);
          fund.querySelector('.range-output').innerHTML = isNaN(value) ? '-' : (numberFormatter.format(value) + '%');
        });

      });
    }
  }
});